// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3p1Uk","left":"styles_left__2VFYn"};